module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-eofy.21b433e4.png";